@if (options?.length == 1) {
    <aurora-icon-button
        variant="ghost"
        size="xlarge"
        icon="help"
        label="Insurity Knowledge Center"
        (click)="clickOption(options[0])">
    </aurora-icon-button>
} @else {
    <div class="ikc-menu-dropdown" (click)="$event.stopPropagation()">
        <aurora-icon-button
            variant="ghost"
            size="xlarge"
            icon="help"
            label="Insurity Knowledge Center"
            (click)="toggleAuroraMenu($event)">
        </aurora-icon-button>

        @if (isIkcMenuOpen) {
        <div class="ikc-menu-dropdown-panel">
            <aurora-menu
                aurora-light
                [items]="auroraMenuItems"
                [showFilter]="false"
                [showEmptyState]="false"
                (item-click)="onAuroraMenuItemClick($event)"
                (menu-close)="isIkcMenuOpen = false">
            </aurora-menu>
        </div>
        }
    </div>
}
